module.exports = __webpack_public_path__ + "static/media/IMG_1568(1).1bfb28a6.jpg";